/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useCallback, useEffect, useState } from 'react';

import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { motorwayMovePageEvents } from 'Services/analytics/events/motorwayMoveEvents';

export const useVideoModal = () => {
	const [state, setState] = useState<boolean>(false);

	const closeModal = useCallback(() => {
		motorwayMovePageEvents({
			name: 'Motorway Move video modal closed',
			schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
			version: SNOWPLOW_EVENTS.CLICK.VERSION,
		});

		setState(false);
	}, []);

	const openModal = useCallback(() => {
		motorwayMovePageEvents({
			name: 'Motorway Move video modal opened',
			schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
			version: SNOWPLOW_EVENTS.CLICK.VERSION,
		});

		setState(true);
	}, []);

	useEffect(() => {
		document.body.style.overflow = state ? 'hidden' : '';
	}, [state]);

	return {
		closeModal,
		openModal,
		state,
	};
};
